import { ArrowLeftOutlined, FileTextOutlined } from "@ant-design/icons";
import { Button, Card, Col, Drawer, Form, Input, Row, Modal, Radio, message } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./FinalAppSubmission.css";
import Tabs from "../../components/Tab/Tab";
import { VscFilePdf } from "react-icons/vsc";
import { TiTickOutline } from "react-icons/ti";
import axios from "../../axios-request/request.methods";
import axiosRequest from "../../axios-request/request.methods";
import * as actions from "../../store/actions/index";
import * as leadActions from "../../store/actions/leads";
import Loader from "../Loader/Loader";
import { tabMenuList } from "../Tab/ProposalFormTabList";




const FinalAppSubmission = () => {
  const isManagerView = useSelector((state) => state?.leads?.globalTab);

  const tabMenu2 = tabMenuList(isManagerView);
  const history = useHistory();
  let dispatch = useDispatch();
  const DOCStore = useSelector((state) => state);
  //console.log("DOCSStore", DOCStore);
  const [width, setWidth] = useState(window.innerWidth);
  const [form] = Form.useForm();
  const breakpoint = 620;
  const salary = useSelector((state) => state.proposalDetails?.allProposal);
  console.log("salary---------", salary)
  const [selectedTypeOfJourney, setSelectedTypeOfJourney] = useState(null);

  // Get global tab state to determine if we're in Team view
  const globalTab = useSelector((state) => state.leads?.globalTab);

  let proposalId = useSelector((state) => state.proposalDetails?.allProposal?._id);

  //console.log("Propsal Data=========> ", proposalId);
  const prevdHandler = (event) => {
    event.preventDefault();

    history.push("/esir");
  };
  const prevdHandler2 = (event) => {
    event.preventDefault();
    setOpen(false);
    setOpenFinal(true);
  };
  const proceedHandled = (event) => {
    history.push("/home");
    localStorage.removeItem("propsalid");
    dispatch(actions.fetchAllProposalSuccess({}));
    dispatch(actions.fetchBi({}));
    dispatch(actions.fetchEinsurance({}));
    dispatch(actions.fetchFinancialDetails({}));
    dispatch(actions.fetchAboutCustomer({}));
    dispatch(actions.fetchHealthDetails({}));
    dispatch(actions.fetchPreviousPolicyDetails({}));
    dispatch(actions.fetchNominationDetails({}));
    dispatch(actions.fetchProposalDetails({}));
    dispatch(actions.fetchPayments({}));
    dispatch(actions.fetchDelarationSuccess({}));
  };

  const [open, setOpen] = useState(false);
  const [openFinal, setOpenFinal] = useState(true);
  const [Pdfdata, setpdfdata] = useState(null);
  const [documnetObject, setdocumnetObject] = useState(null);

  const [medicalOption, setMedicalOption] = useState(null);
  const [newMedicalPopUp, setNewMedicalPopUp] = useState(false);
  const [pendingMedicalPopUp, setPendingMedicalPopUp] = useState(false);
  const [medicalDetailsModal, setMedicalDetailsModal] = useState(false);
  const [pendingMedicalDetailsModal, setPendingMedicalDetailsModal] = useState(false);
  const [medicalTestsList, setMedicalTestsList] = useState([]);
  const [medicalCodes, setMedicalCodes] = useState([]);
  const [redirectionLink, setRedirectionLink] = useState(null);
  const medicalTestMaster = useSelector((state) => state.leads.medicalTestMaster);
  const fetchMedicalTestMasterLoading = useSelector((state) => state.leads.fetchMedicalTestMasterLoading);

  const liAge = salary?.benefitIllustration?.lifeInsuredEntryAge;
  const liSalary = salary?.benefitIllustration?.SumAssured;

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleVerify = () => {
    setOpen(false);
    setOpenFinal(false);
  };

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [width]);

  useEffect(() => {
    let _temp = window.localStorage.getItem("propsalid");
    getMedicalRecords();
    dispatch(leadActions.fetchMedicalTestMaster());
    //console.log("_temp", JSON.parse(_temp)?.proposalID);
    const LocalID = JSON.parse(_temp)?.proposalID;
    const ProposalLocalId = LocalID;
    //console.log("ProposalLocalId~~~", ProposalLocalId);

    dispatchGetProposal();

    {
      proposalId
        ? axios
          .get(`user/getProposal/${proposalId}?onlyPdfData=true`)
          .then((res) => {
            //console.log("Datat===>>>", res);
            // if(res?.data?.errCode === -1){
            let PdfResponse = res[0];
            setpdfdata(PdfResponse);

            let tempdata = PdfResponse?.All_Proposal_PDF;
            Object.keys(tempdata).forEach((key) => {
              if (tempdata[key] === null) {
                delete tempdata[key];
              }
            });
            const propertyValues = Object.values(tempdata);

            // let data = propertyValues.filter=>{checkAdult};
            let filterdata = propertyValues.filter((data) => data.status !== "pending");
            setdocumnetObject(filterdata);
            //console.log("Temp Data", filterdata);
            // //console.log("Proposal Name:",Pdfdata[0]?.benefitIllustration?.NameOfProposer)

            // }else{

            // }
          })
          .then((err) => {
            //console.log(err);
          })
        : axios
          .get(`user/getProposal/${ProposalLocalId}?onlyPdfData=true`)
          .then((res) => {
            //console.log("Datat===>>>", res);
            // if(res?.data?.errCode === -1){
            let PdfResponse = res[0];
            setpdfdata(PdfResponse);

            let tempdata = PdfResponse?.All_Proposal_PDF;
            Object.keys(tempdata).forEach((key) => {
              if (tempdata[key] === null) {
                delete tempdata[key];
              }
            });
            const propertyValues = Object.values(tempdata);

            // let data = propertyValues.filter=>{checkAdult};
            let filterdata = propertyValues.filter((data) => data.status !== "pending");
            setdocumnetObject(filterdata);
            //console.log("Temp Data", filterdata);
            // //console.log("Proposal Name:",Pdfdata[0]?.benefitIllustration?.NameOfProposer)

            // }else{

            // }
          })
          .then((err) => {
            //console.log(err);
          });
    }
  }, []);

  const dispatchGetProposal = async () => {
    let _temp = window.localStorage.getItem("propsalid");
    const LocalID = JSON.parse(_temp)?.proposalID;
    const ProposalLocalId = LocalID;
    let tracker_res = await axiosRequest.get(`user/getProposal/${ProposalLocalId}`);
    //console.log(tracker_res, "tracker_res_");
    if (tracker_res && tracker_res[0]) {
      let proposalData = tracker_res[0];
      dispatch(actions.fetchAllProposalSuccess(proposalData));
      dispatch(actions.fetchBi(proposalData?.benefitIllustration));
      dispatch(actions.fetchEinsurance(proposalData?.elinsuranceAccountDetails));
      dispatch(actions.fetchFinancialDetails(proposalData?.FinancialDetails));
      dispatch(actions.fetchAboutCustomer(proposalData?.AboutCustomer));
      dispatch(actions.fetchHealthDetails(proposalData?.HealthDetailsSection));
      dispatch(actions.fetchPreviousPolicyDetails(proposalData?.PreviousPolicyDetails));
      dispatch(actions.fetchNominationDetails(proposalData?.NominationDetails));
      dispatch(actions.fetchProposalDetails(proposalData?.ProposerDetails));
      dispatch(actions.fetchPayments(proposalData?.paymentOptions));
      dispatch(actions.fetchDelarationSuccess(proposalData?.Declaration));

      // Check for medical applicability from API response
      // const isAlreadyShown = sessionStorage.getItem(`medicalModalShown_${ProposalLocalId}`);
      const isSmartVital = proposalData?.productId?.productName === "Aviva Smart Vitals V02" || proposalData?.productId?.productName === "Aviva Smart Vitals";
      const tpaTriggered = proposalData?.tpaData?.tpaTriggered;
      if ((proposalData.medicalApplicabilityDetails?.bypassMedical === false && isSmartVital && (tpaTriggered || proposalData?.benefitIllustration?.typeOfJOurney === "Non-POS")) || (!isSmartVital && proposalData.medicalApplicabilityDetails?.isMedicalApplicable && proposalData.medicalApplicabilityDetails?.checkStatus === "COMPLETED" && (tpaTriggered || proposalData?.benefitIllustration?.typeOfJOurney === "Non-POS"))) {
        const indCodes = proposalData.medicalApplicabilityDetails.medicalTestsIndCodes || [];
        const pkgCodes = proposalData.medicalApplicabilityDetails.medicalTestsPkgCodes || [];
        // console.log("codesss....", indCodes, pkgCodes)

        // handle combination codes like "UFR UDS UBL" for pkgcodes
        const processCodes = (codes) => codes.flatMap(code => (typeof code === 'string' ? code.trim().split(/\s+/) : code)).filter(Boolean);

        const combinedCodes = [...processCodes(indCodes), ...processCodes(pkgCodes)];

        // console.log("combineeeeeeee",combinedCodes)
        setMedicalCodes(combinedCodes);
        setMedicalDetailsModal(true);
        // sessionStorage.setItem(`medicalModalShown_${ProposalLocalId}`, "true");
      }
    }
  };

  useEffect(() => {
    if (!medicalDetailsModal && pendingMedicalPopUp) {
      setNewMedicalPopUp(true);
      setPendingMedicalPopUp(false);
    }
  }, [medicalDetailsModal, pendingMedicalPopUp]);

  useEffect(() => {
    if (medicalDetailsModal && newMedicalPopUp) {
      setNewMedicalPopUp(false);
      setPendingMedicalPopUp(true);
    }
  }, [medicalDetailsModal, newMedicalPopUp]);

  useEffect(() => {
    if (medicalCodes.length > 0 && medicalTestMaster) {
      const testDescriptions = medicalCodes.map((code) => medicalTestMaster[code] || code);
      setMedicalTestsList(testDescriptions);
    }
  }, [medicalCodes, medicalTestMaster]);

  const getMedicalRecords = () => {
    let typeOfJourney = salary?.benefitIllustration?.typeOfJOurney;
    //console.log("issue type of journey", typeOfJourney);
    setSelectedTypeOfJourney(typeOfJourney);
    //console.log(":toj", typeOfJourney);

    // Get the product name
    const productName = salary?.productId?.productName;
    //console.log("Product Name:", productName);

    // In Team View, bypass the Medical Required modal for Term insurance products
    if (globalTab === "team" || productName === "Aviva Smart Vitals" || productName === "Aviva Smart Vitals V02") {
      setNewMedicalPopUp(false);
      return;
    }

    if (typeOfJourney == "Non-POS") {
      // //console.log("hello creating new popup");
      // POS
      // return;

      axiosRequest.get("admin/getAllMedicalRecords").then((res) => {
        //console.log(res);
        if (res) {
          // setNewMedicalPopUp(true);
          let medArr = res.medicalGridDATA;
          let minAge = null;
          let maxAge = null;
          let salaryLowerRange = null;
          let salaryUpperRange = null;
          medArr.map((item) => {
            const filteredArray = item.ageRange.split(" ").filter((item) => item !== "–");
            const transformedArray = filteredArray.filter((item) => item.trim() !== "");
            //console.log("transformedArray", transformedArray);

            minAge = transformedArray[0];
            maxAge = transformedArray[1];
            //for Salary Range
            const filteredSalaryArray = item.salaryRange.split("to").filter((item) => item !== " ");
            salaryLowerRange = filteredSalaryArray[0];
            salaryUpperRange = filteredSalaryArray[1] == undefined ? "" : filteredSalaryArray[1];
            if (liAge >= minAge && liAge <= maxAge && CheckSalary(salaryLowerRange, salaryUpperRange, liSalary) == true) {
              //console.log("item-->", item);
              let allMedicalRec = [];
              if (res?.medlink1) {
                setPendingMedicalPopUp(true);
                allMedicalRec.push(item, res.medlink1);
                allMedicalRec.push(res.medlink2);

                setMedicalOption(allMedicalRec);
                //console.log("Medical options-->", allMedicalRec);
              } else {
                setNewMedicalPopUp(false);
              }
            }
          });
        } else {
          setNewMedicalPopUp(false);
        }
      });
    } else {
    }
  };

  const handleRadioLinkChange = (event) => {
    //console.log("Radio value", event.target.value);
    setRedirectionLink(event.target.value);
  };

  const handleMedicalGridContinue = () => {
    if (redirectionLink !== null) {
      let url = redirectionLink;
      window.open(url, "_blank");
      setNewMedicalPopUp(false);
    } else {
      message.error("Select a link before proceeding to book an appointment.");
    }
  };

  const openMedicalGridOnButtonCall = () => {
    // Get the product name
    const productName = salary?.productId?.productName;

    // For Aviva Smart Vitals product, bypass the Medical Required modal
    if (productName === "Aviva Smart Vitals" || productName === "Aviva Smart Vitals V02") {
      setNewMedicalPopUp(false);
      return;
    }

    setRedirectionLink(null);
    setNewMedicalPopUp(true);
    getMedicalRecords();
  };

  const handleModalClose = () => {
    setNewMedicalPopUp(false);
  };

  const CheckSalary = (minSalary, maxSalary, liSalary) => {
    //remove spaces
    const actualMinSalary = minSalary.trim();
    const actualMaxSalary = maxSalary ? maxSalary.trim() : "";
    // Define a mapping for salary units to numeric multipliers
    const unitMultipliers = {
      Cr: 10000000, // Crore
      Lacs: 100000, // Lakhs
      Thousands: 1000, // Thousands
      Hundreds: 100, // Hundreds
    };
    // Extract the numeric value and unit from minSalary and maxSalary
    let [minValue, minUnit] = actualMinSalary.split(" ");
    let [maxValue, maxUnit] = actualMaxSalary.split(" ");
    // Handle "Above" case
    if (minValue == "Above" && minUnit == "15" && maxValue === "" && maxUnit == undefined) {
      maxValue = "15"; // Set a very large value for "Above" case
      maxUnit = "Cr"; // Set the unit to Crore
    }
    // Check if minSalary is "Above" and treat it as a special case
    if (actualMinSalary === "Above 15 Cr") {
      // Check if actualMaxSalary is empty or not
      if (maxValue === "" || isNaN(maxValue)) {
        return false; // Invalid range, return false
      }
      const maxSalaryInUnit = parseFloat(maxValue) * unitMultipliers["Cr"];
      const liSalaryNumeric = parseFloat(liSalary);
      return liSalaryNumeric >= maxSalaryInUnit;
    }
    // Convert liSalary to a numeric value
    const liSalaryNumeric = parseFloat(liSalary);
    // Calculate the min and max salary in a common unit (Crore,lacs,Tousand,Hundred)
    const minSalaryInUnit = parseFloat(minValue) * unitMultipliers[minUnit];
    const maxSalaryInUnit = parseFloat(maxValue) * unitMultipliers[maxUnit];
    if (liSalaryNumeric >= minSalaryInUnit && liSalaryNumeric <= maxSalaryInUnit) {
      return true; // liSalary is within the range
    } else {
      return false; // liSalary is outside the range
    }
  };

  const GenratePdf = (e) => {
    let pdf = "";
    if (e !== undefined || e !== null || e !== "") {
      //console.log("EVENT", e);
      if (e.status != "pending" && e.name != "Proposer Addendum PDF" && e.name != "Data Consent PDF") {
        //console.log("TRUEEEEE");
        return true;
      } else {
        //console.log("FALSEEEEE");
        return false;
      }
    } else {
      return false;
    }
  };

  return (
    <>
      <Tabs header="Proposal" tabMenu={tabMenu2} activeKey="finalSubmit" />
      <Loader formloader={fetchMedicalTestMasterLoading} />

      <div className="FinalRow">
        <Row
          gutter={[0, 30]}
          justify={width > breakpoint ? "" : "center"}
          style={width > breakpoint ? "" : { marginTop: "20px" }}
          className="row_gapOTP"
        >
          <Col xs={18} sm={18} md={18} lg={12} xl={12} offset={width > breakpoint ? 6 : 0} className="FinalCOLLLL">
            <Card
              bordered={false}
              style={{
                width: "{width > breakpoint ? 600 : 350 }",
                borderRadius: "10px",
                display: "flex",
              }}
            >
              <p className="otpVerification__text">Documents Uploaded</p>
              <Row gutter={24}>
                {documnetObject?.length > 0 ? (
                  <>
                    {documnetObject?.map(
                      (item, index) =>
                        GenratePdf(item) && (
                          <Col span={12}>
                            <a href={item?.location} target="_blank">
                              <VscFilePdf /> VIEW & DOWNLOAD
                            </a>
                            <p className="Verify__text dash">{item?.name}</p>
                          </Col>
                        )
                    )}
                  </>
                ) : (
                  <Col span={25}>
                    <p className="Verify__text dash">{"No Data Found!"}</p>
                  </Col>
                )}
              </Row>
            </Card>
          </Col>
          <Col xs={18} sm={18} md={18} lg={12} xl={12} offset={width > breakpoint ? 6 : 0} className="FinalCOLLLL">
            <Card
              bordered={false}
              style={{
                width: "{width > breakpoint ? 600 : 350 }",
                borderRadius: "10px",
              }}
            >
              {/* <Button
                  className="last-btn-1 primary"
                  onClick={prevdHandler2}
                  style={{
                    border: "1",
                    alignItems: "center",
                    color:"#FFFFFF",
                    backgroundColor:'#1A60BC'
                  }}
                  icon={<ArrowLeftOutlined />}
                >
                  Previous
                </Button> */}

              {selectedTypeOfJourney === "Non-POS" && (salary?.productId?.productName !== "Aviva Smart Vitals" && salary?.productId?.productName !== "Aviva Smart Vitals V02") ? (
                <Button className="getFinalButton" onClick={openMedicalGridOnButtonCall}>
                  Medical Grid
                </Button>
              ) : null}

              {salary?.medicalApplicabilityDetails?.isMedicalApplicable && salary?.benefitIllustration?.typeOfJOurney === "Non-POS" && (
                <Button style={{ marginRight: "5px" }} className="getFinalButton" onClick={() => setMedicalDetailsModal(true)}>
                  Medical Requirements
                </Button>
              )}

              <Button
                className="getFinalButton"
                onClick={() => {
                  proceedHandled();
                }}
              >
                Back to Dashboard
              </Button>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Modal for Medical Grid */}
      {selectedTypeOfJourney === "Non-POS" && (salary?.productId?.productName !== "Aviva Smart Vitals" && salary?.productId?.productName !== "Aviva Smart Vitals V02") ? (
        <Modal
          title="Medical Required"
          visible={newMedicalPopUp}
          width={width > breakpoint ? "40vw" : "90vw"}
          footer={null}
          mask={true}
          maskStyle={{ backgroundColor: "rgb(0, 0, 0, 0.5)" }}
          bodyStyle={{
            overflowX: "hidden",
            height: "auto",
          }}
          onCancel={handleModalClose}
          style={{ overflowX: "hidden" }}
        >
          <div className="inner-grid-container">
            <Row gutter={16} style={{ marginTop: 10, marginBottom: 10 }}>
              <b>Please click on the below link to book an appointment.</b>
            </Row>

            {medicalOption === null ? null : (
              <>
                <Row gutter={16}>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Radio.Group onChange={handleRadioLinkChange} value={redirectionLink}>
                      {medicalOption[2] ? (
                        <Radio value={medicalOption[2]}>
                          <p className="appointment-inner-header">MD India TPA</p>
                          <div>
                            <a href="#">{medicalOption[2]}</a>
                          </div>
                        </Radio>
                      ) : null}

                      {medicalOption[1] ? (
                        <Radio value={medicalOption[1]} style={{ marginTop: 30 }}>
                          <p className="appointment-inner-header">GoWelnext TPA</p>
                          <div>
                            <a href="#">{medicalOption[1]}</a>
                          </div>
                        </Radio>
                      ) : null}
                    </Radio.Group>
                  </Col>
                </Row>

                <Row align="center" style={{ marginTop: 30 }}>
                  <Button className="getFinalButton" onClick={handleMedicalGridContinue}>
                    Continue
                  </Button>
                </Row>
              </>
            )}
          </div>

          {/* <div className="button">
                      <Form.Item>
                        <Button
                          // htmlType="submit"
                          // onClick={handleSaveForm}
                          className="button-details"
                        >
                          Cancel
                        </Button>
                      </Form.Item>
                    </div> */}
        </Modal>
      ) : null}

      {/* Modal for Medical Applicability from API */}
      <Modal
        title="Mandatory Medical Test"
        visible={medicalDetailsModal}
        width={width > breakpoint ? "40vw" : "90vw"}
        footer={null}
        mask={true}
        maskStyle={{ backgroundColor: "rgb(0, 0, 0, 0.5)" }}
        bodyStyle={{
          overflowX: "hidden",
          height: "auto",
        }}
        onCancel={() => setMedicalDetailsModal(false)}
        style={{ overflowX: "hidden" }}
      >
        <div className="medical-test-body">
          <Row gutter={16} style={{ marginTop: 10, marginBottom: 10 }}>
            <Col span={24}>
              {medicalTestsList.length > 0 ? (
                <>
                  <p><b>Required Medical Tests:</b></p>
                  <ul style={{ paddingLeft: "15px", marginTop: "10px" }}>
                    {medicalTestsList.map((test, index) => (
                      <li key={index} style={{ marginBottom: "5px" }}>{test}</li>
                    ))}
                  </ul>
                </>
              ) : (
                <p><b>No Medical Test Required</b></p>
              )}
            </Col>
          </Row>

          <div className="medical-test-ok-btn">
            <Button className="getFinalButton" onClick={() => setMedicalDetailsModal(false)}>
              OK
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FinalAppSubmission;
